var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_animation"},[_vm._v("\n\tLoading...\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/LoadingAnimation.vue